module.exports = __webpack_public_path__ + "img/PriceQuotationDetails.ce365c9c.svg";